import { render, staticRenderFns } from "./TermsAndPolicyError.vue?vue&type=template&id=4b2a2e1f&scoped=true&"
import script from "./TermsAndPolicyError.vue?vue&type=script&lang=ts&"
export * from "./TermsAndPolicyError.vue?vue&type=script&lang=ts&"
import style0 from "./TermsAndPolicyError.vue?vue&type=style&index=0&id=4b2a2e1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2a2e1f",
  null
  
)

export default component.exports